import RevolvingFundsError from './RevolvingFundsError';
class RevolvingFundIsNotSet extends RevolvingFundsError {
    propertyId;
    constructor(propertyId, options) {
        super('Property revolving funds not established', options);
        this.propertyId = propertyId;
    }
}
export default RevolvingFundIsNotSet;
